import { useSbLogger } from 'components/app/storyboard/_mediator/use-sb-logger';
import { useSbPlayerContext, ProgressPayload } from '../_mediator/sb-player.provider';
import { PlayerPayload } from '../sb-player-video';
import { LoaderPayload, useLoader } from './use-loader';

const PARAMS = {
  maxLoaderWait: 90 * 1000,
  maxLoaderTime: 3,
};

export const useLoaderReady = (index: Index, playerPayload: PlayerPayload, clipId?: ClipId) => {
  const { sbPlayerGetPayload, sbPlayerReady } = useSbPlayerContext();
  const loaderPayload: LoaderPayload = { src: 'R', index, clipId };
  const logger = useSbLogger()?.loaderReady(index);

  const cb = () => {
    sbPlayerReady(index);
    logger?.onReady();
  };

  const { onLoaderProgress, runLoader, cancelLoader, isLoaderReady } = useLoader(
    cb,
    PARAMS,
    loaderPayload,
    playerPayload
  );

  const onProgress = (data: ProgressPayload) => {
    onLoaderProgress(data);
  };

  const onReady = () => {
    cancelLoader();
    if (isLoaderReady(sbPlayerGetPayload(index)!)) cb();
    else runLoader();
  };

  const cancel = () => {
    cancelLoader();
  };

  return { onReady, cancel, onProgress };
};
